import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import {
  AlertService,
  CampaignService,
  CRMService,
  DeploymentLinkService,
  LoaderService,
  UserService
} from '../_services';
import { FormBuilder } from '@angular/forms';
import {CRM, DeploymentLink} from "../_models";
import { CRMNewComponent } from "./crm-new.component";
import {copyToClipboard} from '../_helpers';
import {NgxSmartModalService} from 'ngx-smart-modal';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './crm-edit.component.html',
  styleUrls: ['./crm.component.css']
})
export class CRMEditComponent extends CRMNewComponent implements OnInit {
  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected crmService: CRMService,
    protected formBuilder: FormBuilder,
    protected alertService: AlertService,
    protected userService: UserService,
    protected modalService: NgxSmartModalService,
    protected loaderService: LoaderService,
    protected linkService: DeploymentLinkService,
    protected campaignService: CampaignService
  ) {
    super(router, location, route, crmService, formBuilder, alertService, userService, modalService, loaderService,
      linkService, campaignService);
    this.isNew = false;
    this.title = 'Edit Your Platform';
  }

  ngOnInit() {
    super.ngOnInit();

    this.data$.subscribe((crm: CRM) => {
      if (crm) {
        this.crm = crm;
        this.form.patchValue({
          type: crm.type,
          subscription_plugin: crm.subscription_plugin,
          max_fulfillments: crm.max_fulfillments,
          max_transactions: crm.max_transactions,
          auto_approve: crm.auto_approve,
          use_partial_refunds: crm.use_partial_refunds,
          use_partial_charges: crm.use_partial_charges,
          allow_update_fulfillment: crm.allow_update_fulfillment,
          link_id_field: crm.link_id_field,
          link_field_type: crm.link_field_type,
          display_name: crm.display_name,
          auto_sync: crm.auto_sync,
          parent_crms: this.buildParentCRMItems(crm.parent_crms),
          store_credit_crm: crm.store_credit_crm,
          sync_using_batch: crm.sync_using_batch,
          owns_fulfillment: crm.owns_fulfillment,
        });

        if (crm.type in this.typeMap) {
          this.selectedType = this.typeMap[crm.type];
          this.buildSubscriptionPluginList();
          if (!crm.display_name) {
            this.form.patchValue({display_name: this.selectedType.name})
          }
        }

        if (crm.subscription_plugin && crm.subscription_plugin in this.subscriptionPluginMap) {
          this.selectedSubscriptionPlugin = this.subscriptionPluginMap[crm.subscription_plugin];
        }

        if (crm.shopify_public_plugin && crm.shopify_public_plugin.link) {
          this.linkService.get(crm.shopify_public_plugin.link).subscribe(
            (link: DeploymentLink) => {
              this.deploymentLink = link;
            },
            error => {
              this.handleError(error);
            }
          );
        }

        this.updateFields();
      }
    });
  }

  protected onSaveComplete(data) {
    this.loading = false;
    this.goBack();
  }

  protected onCrmsLoaded() {
    super.onCrmsLoaded();

    // re-map the selected parent crms now that the crm list (and names) is available
    if (this.crm) {
      this.form.patchValue({ parent_crms: this.buildParentCRMItems(this.crm.parent_crms) });
    }
  }

  private buildParentCRMItems(crmIds: (string | number)[]) {
    return (crmIds || []).map((crmId) => ({
      id: crmId,
      name: this.crmNameMap[crmId] || crmId,
    }));
  }

  protected readonly copyValue = copyToClipboard;
}
